import React from 'react';
import Otp from 'react-otp-input';
import { connect } from 'react-redux';
import * as clevertapRegister from 'clevertap/register';
import { Trans, t } from '@lingui/macro';
import styles from './style.css';

class OtpInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      otpError: false,
      seconds: 60,
      otp: '',
      count: 3,
      key: 1,
    };
  }

  componentDidMount() {
    $('.otp-input input').attr('type', 'number');
  }

  componentWillReceiveProps(nextProps) {
    const { otpError } = nextProps;
    if (otpError !== null) {
      this.clearOtp();
      if (otpError === 'INVALID_REQUEST') {
        this.setState({ seconds: 0, count: 0 });
      }
      if (otpError === 'RESEND_OTP') {
        this.setState({
          count: 3,
          otpError: false,
          otp: '',
        });
        this.props.dispatch(this.props.setOtpError(null));
      }
    }
    this.setState({
      otpError: otpError !== null,
    });
    if (this.myInterval === false && this.state.count > 0) {
      this.setState({
        seconds: 60,
      });
    }
    clearInterval(this.myInterval);
    this.myInterval = setInterval(() => {
      this.setState(prevState => ({
        seconds: prevState.seconds - 1,
      }));
    }, 1000);
  }

  componentWillUnmount() {
    this.props.dispatch(this.props.showOtpAction(false));
    clearInterval(this.myInterval);
  }

  clearOtp = () => {
    this.setState({ key: this.state.key + 1, otp: '' });
  };

  handleOtpInput = otp => {
    const { phone } = this.props;
    const email = this.props.data.moka.user
      ? this.props.data.moka.user.email
      : '';
    if (otp.trim().length === 1) {
      clevertapRegister.clevertapTracker('OTP Input', { email, phone });
    }
    if (otp.length === 6) {
      if (isNaN(otp) || otp.trim().length !== 6) {
        this.setState({
          otpError: true,
          count: this.state.count - 1,
        });
        this.clearOtp();
      } else {
        this.setState(prevState => ({
          count: prevState.count - 1,
          otpError: false,
        }));
        this.props.dispatch(this.props.setOtpError(null));
        this.state.count > 0 ? this.props.handleOtpSubmit(otp) : null;
      }
    }
    $('.otp-input :input').each(function() {
      const input = $(this);
      $(input).css('border-bottom-color', '#d8d8d8');
      if (input.val().length !== 0) {
        $(input).css('border-bottom-color', '#2d7ab8');
      }
    });
    this.setState({
      otp,
    });
  };

  handleResendOtp = phone => {
    this.clearOtp();
    this.setState({
      count: 3,
      otpError: false,
      otp: '',
    });
    this.props.dispatch(this.props.setOtpError(null));
    this.props.handleResendOtp(phone);
  };

  showErrorMessage = () => {
    if (this.props.otpError === 'INVALID_REQUEST') {
      clearInterval(this.myInterval);
      return t`Verification code expired. Please resend a new code.`;
    }
    const { otpError, count } = this.state;
    if (otpError) {
      if (count <= 0) {
        return t`You have 0 try left. Please resend a new code.`;
      }
      if (count === 2) {
        return t`Enter a valid verification code. You have ${count} tries left.`;
      }
      if (count === 1) {
        return t`Enter a valid verification code. You have ${count} try left.`;
      }
    }
  };

  render() {
    const { seconds, otpError, count, key } = this.state;
    const { handleBackClick, phone, className } = this.props;
    let { timer } = this.props;
    if (seconds === 0) {
      clearInterval(this.myInterval);
      this.myInterval = false;
      timer = false;
    }
    return (
      <div className={`${styles['otp-container']} ${styles[className]}`}>
        <h2 className={`${styles.heading}`}>
          <Trans>Enter the verification code we just sent to</Trans>
        </h2>
        <p className={`${styles['phone-number']}`}>{phone}</p>
        <Otp
          key={key}
          onChange={otp => this.handleOtpInput(otp)}
          numInputs={6}
          shouldAutoFocus
          isDisabled={count < 1}
          containerStyle={`${styles.input} otp-input ${
            otpError ? styles['border-red'] : ''
          }`}
        />
        <p className={`${styles.error}`}>
          <Trans id={this.showErrorMessage()} />
        </p>
        <div className={`row ${styles['row-center']}`}>
          <div className="col-md-6 col-xs-6 col-sm-6">
            <button
              className={`btn btn-default btn-block ${styles['back-btn']}`}
              type="button"
              onClick={handleBackClick}
            >
              Back
            </button>
          </div>
          <div className="col-md-6 col-xs-6 col-sm-6">
            <button
              className={`btn btn-primary btn-block`}
              disabled={timer}
              type="button"
              onClick={() => this.handleResendOtp(phone)}
            >
              {timer ? (
                <Trans>Resend ({seconds}s)</Trans>
              ) : (
                <Trans>Resend Code</Trans>
              )}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

function select(state) {
  return {
    data: state,
  };
}

export default connect(select)(OtpInput);
